import React, {useEffect, useState, useRef} from "react";
import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid, InputAdornment,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    IconButton
} from "@mui/material";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import SearchIcon from '@mui/icons-material/Search';
import Loading from "../Layout/Loading";
import {HistoryListArrayType, HistoryList} from "../../api/historyAPI";

function HistoryConfig() {

    const [loading, setLoading] = useState<boolean>(true);
    const [historyData, setHistoryData] = useState<HistoryListArrayType>([]);
    const [total_count, setCount] = useState<number>(0);
    const [page, setPage] = useState<number>(0);
    const [size, setSize] = useState<number>(10);
    const [searchValue, setSearchValue] = useState<string>("");
    const [searchKeyword, setSearchKeyword] = useState<string>("");
    const [statusFilter, setStatusFilter] = useState<string>("failed");
    const [errorOpen, setErrorOpen] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const isFirstRender = useRef(true);

    const handleShowErrorMsg = (message: string) => {
        setErrorMessage(message);
        setErrorOpen(true);
    }

    const handleCloseErrorMsg = () => {
        setErrorOpen(false);
        setErrorMessage("");
    }

    const historyColumns: GridColDef[] = [
        { field: 'id'},
        { field: 'name', headerName: '프로세스 이름', flex: 2},
        { field: 'start', headerName: '시작시간', flex: 1 },
        { field: 'end', headerName: '종료시간', flex:1},
        { field: 'status', headerName: '상태', flex:1},
        { field: 'count', headerName: '수집건수', flex:1},
        { field: 'writer', headerName: '사용자', flex:1},
        {
            field: 'error',
            headerName: '에러',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const errorMsg = params.row.error;
                return errorMsg && errorMsg.trim() !== '' ? (
                    <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => handleShowErrorMsg(errorMsg)}
                    >
                        에러 보기
                    </Button>
                ) : null;
            }
        }
    ]

    const handleHistoryListFetch = (isPageload: boolean) => {
        if (isPageload) {
            setLoading(true);
        }else{
            setLoading(false);
        }

        HistoryList(page, size, searchKeyword, statusFilter).then(data => {
            setHistoryData(data.data);
            setCount(data.total);
            setLoading(false);
        });

    }

    const handleHistorySearch = () => {
        setPage(0);
        setSearchKeyword(searchValue);
    }

    const handleStatusFilterChange = (value: string) => {
        setPage(0);
        setStatusFilter(value);
    }

    useEffect(() => {
        handleHistoryListFetch(true);
        // setLoading(true);
        // HistoryList(page, size).then(data => {
        //     setHistoryData(data.data);
        //     setCount(data.total);
        //     setLoading(false);
        // })
        }, []);

    useEffect(() => {
        if (isFirstRender.current){
            isFirstRender.current = false;
            return;
        }
        handleHistoryListFetch(false);
        // setLoading(true);
        // HistoryList(page, size).then(data => {
        //     setHistoryData(data.data);
        //     setCount(data.total);
        //     setLoading(false);
        // })
        }, [size, page, searchKeyword, statusFilter]);

     if (loading) return <Loading />;


    return (
        <Container maxWidth='xl' sx={{mt:10, mb:2}}>{/* 레이아웃 정리: bm→mb 오타 교정 */}
            <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}
                      sx={{
                          p:0,
                          display:'flex',
                          flexDirection:'row',
                          height:'10%',
                      }}>
                    <Paper sx={{
                        p: 1,
                        display: 'flex',
                        width: '100%',
                    }}>
                        <Grid container spacing={1}>
                            <Grid item lg={8} md={8} xs={8} sx={{
                                display : 'flex',
                                alignItems: 'center',
                            }}>
                                <Typography sx={{ml:1}} variant='h5'>데이터 수집 이력 관리</Typography>
                            </Grid>
                            <Grid item lg={2} md={2} xs={2} sm={2}>
                                <Select
                                    fullWidth
                                    size="small"
                                    value={statusFilter}
                                    onChange={e => handleStatusFilterChange(e.target.value)}
                                >
                                    <MenuItem value="failed">실패</MenuItem>
                                    <MenuItem value="success">완료</MenuItem>
                                    <MenuItem value="all">전체</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={2} md={2} xs={2} sm={2}>
                                <TextField
                                    fullWidth
                                    id="searchBar"
                                    label="수집 이력 검색"
                                    size="small"
                                    value={searchValue}
                                    onChange={e => setSearchValue(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter') {
                                            handleHistorySearch()
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleHistorySearch}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                >
                                </TextField>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                {/* 레이아웃 정리: mt:1 제거로 다른 목록 화면과 동일한 간격 */}
                <Grid item lg={12} md={12} sm={12} xs={12}
                    sx = {{
                        p:0,
                        display:'flex',
                        flexDirection:'row',
                        height:'90%'
                    }}>
                    <Paper
                        sx={{
                            p:1,
                            display:'flex',
                            height:650,
                            width:'100%',
                        }}>
                        <DataGrid
                            // 레이아웃: flex 부모에서 폭 0 방지(정적 정렬)
                            sx={{ flex: 1, minWidth: 0 }}
                            columns={historyColumns}
                            rows={historyData}
                            // v6: hide 제거 → columnVisibilityModel 로 id 숨김 유지
                            initialState={{ columns: { columnVisibilityModel: { id: false } } }}
                            // v6 서버 페이지네이션: page/pageSize/onPageChange/onPageSizeChange → paginationModel + onPaginationModelChange
                            paginationMode="server"
                            rowCount={total_count}
                            paginationModel={{ page, pageSize: size }}
                            onPaginationModelChange={(model) => { setPage(model.page); setSize(model.pageSize); }}
                            pageSizeOptions={[10, 20, 50]}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <Dialog open={errorOpen} onClose={handleCloseErrorMsg} maxWidth="md" fullWidth>
                <DialogTitle>에러 메시지</DialogTitle>
                <DialogContent>
                    <Paper
                        variant="outlined"
                        sx={{
                            p: 2,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            maxHeight: 420,
                            overflow: 'auto',
                        }}
                    >
                        {errorMessage}
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseErrorMsg}>닫기</Button>
                </DialogActions>
            </Dialog>

        </Container>
    )
}

export default HistoryConfig;
